import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/images/compas-arrow.svg")